"use client";

import React from "react";
import SectionTitle from "./SectionTitle";

type WhyQuestionSkewSectionProps = {
  leftImage?: string;
  imageAlt?: string;
  containerClassName?: string;
  sectionTitle?: {
    subtitle: string;
    title?: string;
    description?: string | string[];
    align?: "left" | "center" | "right";
  };
  backgroundImage?: string;
  boxcontent?: string;
  paragraph?: React.ReactNode;
};

const WhyQuestionSkewSection: React.FC<WhyQuestionSkewSectionProps> = ({
  containerClassName,
  sectionTitle,
  backgroundImage,
  paragraph,
}) => {
  return (
    <section className={`w-full overflow-hidden ${containerClassName || ""}`}>
      <div
        className="w-full h-full 2xl:h-[80vh] section-bg-white"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="flex flex-col md:flex-row items-stretch h-full">
          {/* Left panel */}
          <div className="hidden xl:block xl:w-[45%] h-64 xl:h-auto">
            {/* Optional image can go here */}
          </div>

          {/* Right Content */}
          <div className="w-full xl:w-[55%] flex relative py-4 xl:py-16 overflow-hidden">
            {/* Skewed background for md+ */}
            <div
              className="hidden xl:block absolute top-0 left-0 w-full h-full bg-white/62 backdrop-blur-lg border border-white/48 shadow-lg overflow-hidden"
              style={{
                clipPath: "polygon(16.666% 0%, 100% 0%, 100% 100%, 0% 100%)",
                zIndex: 0,
              }}
            ></div>

            <div className="m-4 sm:m-6 p-4 xl:p-0 xl:w-full back bg-white/48 xl:bg-transparent backdrop-blur-lg xl:backdrop-blur-none grid grid-cols-6 auto-rows-auto relative z-10 overflow-hidden">
              {/* Empty grid placeholder */}
              <div className="hidden xl:block xl:col-span-1 h-20 flex items-center justify-center text-[#999]"></div>

              <div className="col-span-6 xl:col-span-4 gap-6 flex flex-col items-start justify-start text-[#999]">
                {sectionTitle && (
                  <SectionTitle
                    title={sectionTitle.title ?? ""}
                    subtitle={sectionTitle.subtitle ?? ""}
                    description={sectionTitle.description ?? ""}
                    align={sectionTitle.align ?? "left"}
                    descriptionMaxWidth="2xl"
                    highlightRed={true}
                  />
                )}

                <div className="w-full xl:p-11 p-6 sm:p-8 bg-white shadow-2xl ">
                  {paragraph && (
                    <p className="text-base sm:text-lg text-[#1b1b1b] leading-relaxed max-w-full">
                      {paragraph}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyQuestionSkewSection;
